// ==================== plugin import =============== //
import React from 'react'
// ======= css import ========== //
import './step5.css'
// ============== component import ============= //
import FinalSetup from './component/finalSetup/FinalSetup';
const Step5 = (props) => {
    const {
        formValidateError,
        formData
    } = props;
    return (
        <>
            <div>
                <FinalSetup
                    formData={formData}
                    formValidateError={formValidateError}
                    onInputChange={props.onInputChange}
                    isInfoOpenHandler={props.isInfoOpenHandler}
                />
            </div>
        </>
    )
}

export default Step5